import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    auth: localStorage.getItem('token') == null ? false : true,
    user: {},
    menu: ['menu-dashboard'],
    openMenu: [],
    COA: []
  },
  mutations: {
    login (state, token) {
      localStorage.setItem('token', token)
      state.auth = true
    },
    logout (state) {
      localStorage.removeItem('token')
      localStorage.removeItem('ShowModal')
      localStorage.removeItem('OngoingFiles')
      state.auth = false
    },
    user (state, data) {
      state.user = {
        email: data.email,
        full_name: data.full_name,
        username: data.username
      }
    },
    activateMenu (state, data) {
      state.menu = data
    },
    openMenu (state, data) {
      state.openMenu = data
    },
    retrieveCOA(state, data){
      state.COA = data
    }
  },
  getters: {
    auth: state => {
      return state.auth
    },
    user: state => {
      return state.user
    },
    menu: state => {
      return state.menu
    },
    openMenu: state => {
      return state.openMenu
    },
    COA: state => {
      return state.COA
    }
  }
})

export default store